import Button from '~/components/Buttons/Button'
import EmailIcon from '~/components/Icons/svgs/EmailIcon'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import { Link } from '~/components/Link'
import ROUTES from '~/shared/constants/routes.const'

export default function ButtonEmailRegister({
  buttonText,
  redirectRoute,
}: {
  buttonText: string
  redirectRoute?: string
}): React.ReactElement {
  const query = { from: redirectRoute }
  const redirectRoutePath =
    redirectRoute && redirectRoute.length ? { pathname: ROUTES.REGISTER, query } : ROUTES.REGISTER
  return (
    <Link className="w-full" to={redirectRoutePath}>
      <Button className="bg-purple text-white" isFullWidth size="small">
        <div className="flex items-center">
          <div className="absolute left-0 h-full p-2 px-4">
            <SVGIcon icon={EmailIcon} size={30} />
          </div>
          <div className="text-sm mx-0">{buttonText}</div>
        </div>
      </Button>
    </Link>
  )
}
